export default {
      id: "phone-usage",
      viewBox: "0 0 20.37 20.37",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#phone",
      toString: function () {
        return this.url;
      }
    }